export const EQ_TIMING_TYPE = 1;
export const RACE_RESULTS_TYPE = 2;

export const DISTANCES_REQUEST = 'DISTANCES_REQUEST';
export const SYNC_ENABLE_REQUEST = 'SYNC_ENABLE_REQUEST';
